<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="warea">
                
                    <div class="col-12 m-record" id="moreRcd">
                        <div class="row nav-top">
                            <div class="col-12 ddavc"><span class="nav-back wt" id="backF" onclick="window.location.href='#/withdrawal'"></span><span
                                    class="tfw-5 tf-18" id="MoreRCT">Withdrawal Records</span></div>
                        </div>
                        <div class="row">
                            <div class="col-12" id="dtaod">
                                <div class="row mr-0 pb-1 myma" v-for="row in rechargerecord" :key="row.id">
                                    <div class="col-6 xtl pl-0"><span :class="getclass(row.status)">{{ getstat(row.status) }}</span></div>
                                    <div class="col-6 pt-1 xtr tf-14 pt-1">{{ gettime(row.created_at) }}</div>
                                    <div class="col-6 pt-1">
                                        <div class="row xtl ovfh">
                                            <div class="col-12 pt-1">UPI: <v>{{row.upi}}</v>
                                            </div>
                                            <div class="col-12 pt-2">Ref: {{row.rand}}</div>
                                        </div>
                                    </div>
                                    <div class="col-6 pt-2">
                                        <div class="row xtl">
                                            <div class="col-12 tf-24 xtr tfcdb"><span>
                                                    <g>{{getamount(row.withdraw)}}</g>
                                                </span></div>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-1">
                                        <div class="bdbwd"></div>
                                    </div>
                                    <div class="col-12 pt-1 xtl">paytm:{{getfee(row.paytm)}} | Fee:{{getfee(row.withdraw)}}| Bank: <v>{{row.withdraw}}</v>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="odrea"></div>
                <div class="row" id="footer"></div>
                <div class="row" id="opffp"></div>
                <div class="row" id="anof">
                </div>
                <div class="row" id="dta_ref"></div>
            </div>
        </div>
    </section>
</template>


<script>
import axios from "axios";
export default {
    name: "RechargeRecord",
    data() {
        return {
            userdetails: {
                username: null,
                balance: null,
                period: null,
                page: 1,
                total22: 0
            },
            rechargerecord: {

            },
            info: {

            }

        }

    },
    mounted: function prepare() {
        this.getrecord();
    },
    methods: {
        pop(message) {
            document.getElementById("snackbar").innerHTML = message;
            document.getElementById("snackbar").style.display = "";
            setTimeout(function () { document.getElementById("snackbar").style.display = "none"; }, 1000);
        },
        gettime(time){
        var timeStamp=Date.parse(time);
        const date= new Date(timeStamp);
        var dateFormat =  date.getDate()+
           "/"+(date.getMonth()+1)+" "+date.getHours()+
           ":"+date.getMinutes();
        return dateFormat;
    },
        getrecord() {
            this.userdetails.username = localStorage.getItem('username');
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=withdrawrecord&user=' + this.userdetails.username + '&page1=' + this.userdetails.page).then((res) => {
                this.rechargerecord = res.data;
                console.log(this.rechargerecord);
            }).catch((err) => {
                console.log(err);
            })
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=info&user=' + this.userdetails.username).then((res) => {
                this.info = res.data;
                this.userdetails.total22 = this.info[4].rech;
                if (this.userdetails.total22 > 0) {
                    document.getElementById("norecord").style.display = "none";
                }
                console.log(this.info);
            }).catch((err) => {
                console.log(err);
            })
        },
        getfee(amount){
            if(amount<=1500){
                return 30;
            }else{
                return (amount*100/97);
            }
        },
        getamount(amount){
            if(amount<=1500){
                return (amount*1+30);
            }else{
                return (amount*1+(amount*100/97));
            }
        },
        getstat(stat){
            if(stat=="Withdrawing"){
                return "Completed";
            }else if(stat=="Applying"){
                return 'Processing';
            }else{
                return"Cancelled"
            }
        },
        getclass(sta){
            if(sta=="Withdrawing"){
                return "rcscpv tfs-w bggr"
}else{
    return "rcscpv tfs-w bggry"
}
        },
    }
}

</script>